import React, { useState, useRef } from 'react'

export interface DropzoneProps {
  onFiles: (files: FileList | null) => void
  children: JSX.Element | JSX.Element[] | null
  className?: string
}

function Dropzone({ onFiles, children = null, className }: DropzoneProps) {
  const [canDrop, setCanDrop] = useState(false)
  const enterTarget = useRef<EventTarget | null>(null)

  function handleDragEnter(event: React.DragEvent<HTMLElement>) {
    event.preventDefault()
    event.stopPropagation()
    if (event.dataTransfer.types.includes('Files')) {
      enterTarget.current = event.target
      setCanDrop(true)
    }
  }

  function handleDragOver(event: React.DragEvent<HTMLElement>) {
    event.preventDefault()
    event.stopPropagation()
    event.dataTransfer.dropEffect = 'copy'
  }

  function handleDragLeave(event: React.DragEvent<HTMLElement>) {
    event.preventDefault()
    event.stopPropagation()
    if (enterTarget.current === event.target) {
      setCanDrop(false)
    }
  }

  function handleDrop(event: React.DragEvent<HTMLElement>) {
    event.preventDefault()
    event.stopPropagation()
    if (onFiles && event.dataTransfer.files) {
      onFiles(event.dataTransfer.files)
    }
    enterTarget.current = null
    setCanDrop(false)
  }

  const classNames = ['dropzone']
  if (className) classNames.push(className)
  if (canDrop) classNames.push('can-drop')

  return (
    <div
      className={classNames.join(' ')}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
    >
      {children}
    </div>
  )
}

export default Dropzone
